var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQrIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7705 1.33093H15.7235V4.28493H12.7705V1.33093ZM11.4375 5.61893H17.0535V0.00292969H11.4375V5.61893Z",
    fill: "#161615"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.47167 1.33093H4.42467V4.28493H1.47167V1.33093ZM0.138672 5.60293H5.75467V0.00292969H0.138672V5.60293Z",
    fill: "#161615"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3603 7.84096H15.7183V9.10995H13.3603V7.84096ZM13.3183 6.51996V7.83795H12.0293V9.15695H13.3593V10.443H17.0533V7.79996H15.7233V6.52396L13.3183 6.51996Z",
    fill: "#161615"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7305 14.3759V11.731H17.0545V14.3739H15.7305",
    fill: "#161615"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3904 0.00292969V1.32693H8.06641C8.06641 0.885596 8.06641 0.444263 8.06641 0.00292969H9.3904Z",
    fill: "#161615"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.146484 11.3099H5.74648V16.9099H0.146484V11.3099ZM4.42648 12.6339H1.47348V15.588H4.42648V12.6339Z",
    fill: "#161615"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.74428 7.82996H8.06328V10.4409H9.38528V11.724H12.0343V13.054H9.39528V11.7599H8.06528V10.475H6.73828L6.74428 7.82996Z",
    fill: "#161615"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.06055 14.284L9.94255 14.275H10.7036V15.593H11.9906V16.9049H10.6806V15.6049H9.39555V16.9049H8.06555C8.06555 16.0319 8.06555 15.1539 8.06555 14.2759V14.2809",
    fill: "#161615"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.39214 6.51391H6.74414V5.19591H8.06514V3.86591L9.39114 3.8709C9.39114 4.7529 9.3928 5.63524 9.39613 6.51791",
    fill: "#161615"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3516 14.3709H15.7306V15.6909H14.6805V16.9049H13.3516V14.3709Z",
    fill: "#161615"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M6.74857 6.50891V7.83492L4.10156 7.82991V6.50391L6.74857 6.50891Z",
    fill: "#161615"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M4.10115 7.82996V9.14796H5.38115V10.466H4.08116V9.15996H2.78516V7.82996H4.11116",
    fill: "#161615"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1.45134 7.82495C1.45134 8.62495 1.45434 9.42694 1.46034 10.2309C1.46034 10.3069 1.46034 10.3819 1.46034 10.4659H0.152344V7.82895H1.45234H1.44734",
    fill: "#161615"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M8.06981 1.3219H6.75781V3.8699H8.06981V1.3219Z",
    fill: "#161615"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M8.06595 11.7609C8.06595 12.6016 8.06395 13.4426 8.05995 14.2839V14.2789H6.75195V11.7659H8.06595",
    fill: "#161615"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M2.78517 7.8309L1.45117 7.82491H1.45617C1.45617 7.39191 1.45617 6.95991 1.45617 6.51691H2.78017V7.8309",
    fill: "#161615"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3464 13.0499C13.3464 13.4919 13.348 13.9339 13.3514 14.3759H12.0254V13.0499L13.3514 13.0549L13.3464 13.0499Z",
    fill: "#161615"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7127 6.50891H9.38672V9.15691H10.7127V6.50891Z",
    fill: "#161615"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M9.39172 3.87096V2.55896H10.6997V3.86596H9.38672",
    fill: "#161615"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M12.035 9.15192H10.709V10.4639H12.035V9.15192Z",
    fill: "#161615"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3565 13.0549V11.7429H14.6646V13.0499H13.3516",
    fill: "#161615"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8967 2.15796H13.5957V3.45896H14.8967V2.15796Z",
    fill: "#161615"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M3.59592 2.15692H2.29492V3.46092H3.59592V2.15692Z",
    fill: "#161615"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M3.60178 13.4609H2.30078V14.7609H3.60178V13.4609Z",
    fill: "#161615"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrIcon);
export default __webpack_public_path__ + "static/media/qr-icon.c02349aca603c60b6a6665cca6a9a451.svg";
export { ForwardRef as ReactComponent };